import { mediaItems } from './mockData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 mb-4">
              <i className="ri-fire-line text-primary-600 text-sm"></i>
              <span className="text-primary-700 text-xs font-medium">精选推荐</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              精彩推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              每日精选高品质4K超清影视内容，院线大片、热门剧集一网打尽
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
            {mediaItems.map((item) => (
              <div key={item.id} className="group cursor-pointer">
                <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
                  <img
                    src={item.poster}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium">
                      {item.quality}
                    </span>
                  </div>
                  <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                    <span className="text-background-50/80 text-xs">{item.year}</span>
                  </div>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}